export default "__VITE_ASSET__0fc145fc__"